<template>
  <b-modal id="customer-scores" hide-footer :title="type == 'increment' ? 'افزایش امتیاز ' : 'کاهش امتیاز '">
    <form @submit.prevent="addScores">
      <b-form-group v-if="scores">
        <label class="pb-1" for="">
          امتیاز <i class="text-danger">*</i></label
        >
        <b-form-input
          :value="scores.scores | priceinput"
          @input="
            (value) => {
              scores.scores = value !== '' ? +value.replace(/\D/g, '') : '';
            }
          "
        >
        </b-form-input>
      </b-form-group>
      <b-form-group>
        <label class="pb-1" for="">
          توضیحات </label
        >
        <b-form-textarea v-model="description"></b-form-textarea>
      </b-form-group>
      <div class="text-center  mt-3">
        <button v-if="type == 'increment'" class="btn btn-success" :disabled="disabled">افزایش امتیاز</button>
        <button v-else-if="type == 'decrement'" class="btn btn-danger" :disabled="disabled">کاهش امتیاز</button>
      </div>
    </form>
  </b-modal>
</template>
<script>
import ScoresModalImpl from '@@/core/components/customer/ScoresModal/ScoresModalImpl'
export default {
 extends : ScoresModalImpl
};
</script>
